import React, { Component } from "react";
import $ from "jquery";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { AiFillSave } from "react-icons/ai";
import Slideshow from "../Slideshow";

class Refahi extends Component {
  constructor(props) {
    super(props);
    props.clearCalender();
    props.getCalenderPlace();
    props.getUserRequest();
  }
  state = {
    errorMessage: "",
    errorMessageRegister: "",
    marriedText: "",
    isSubmitForce: false,
    marriedClass: "col-12 mb-2 hide",
    underAgeClass: "col-12 mb-2 hide",
    singleClass: "col-12 mb-2 hide",
    myPlace: this.props.calenderPlaceJson,
    myYear: this.props.calenderYearJson,
    myMonth: this.props.calenderMonthJson,
    myLists: this.props.calenderJson,
    calenderSelectID: null,
    isRegister: true,
    isSubmitForceRegister: false,
  };
  componentDidMount() {
    this.handleMonthCalender();
  }
  toggleRegister = () => {
    this.setState({ isRegister: !this.state.isRegister });
    this.props.clearCalender();
  };
  toggleSubmitForce = () => {
    this.setState({ isSubmitForce: !this.state.isSubmitForce });
  };
  toggleSubmitForceRegister = () => {
    this.setState({ isSubmitForceRegister: !this.state.isSubmitForceRegister });
  };
  render() {
    const listItems_Active = this.props.calenderJson.map((myList) => (
      <div
        key={myList.ID}
        className={
          this.props.calenderJson.length > 1
            ? "col-6 mt-2 bg-light dvCalender"
            : "col-12 mt-2 bg-light dvCalender"
        }
        onClick={() => this.selectCalender(myList.ID, this)}
        data-target={myList.ID}
      >
        <div className="w-100 rounded text-center p-1">
          <div className="w-100 mb-2">
            <strong>{myList.Hotel}</strong>
          </div>
          <div className="d-inline-grid mb-2">
            <span className="bg-success text-white px-2 py-1 wp-text">
              {this.props.calenderJson.length > 1 ? (
                <span className="wp-text-small">از </span>
              ) : (
                <span></span>
              )}
              <b>{myList.Start_Date}</b>
            </span>
            {myList.End_Date !== null ? (
              <span className="bg-danger text-white px-2 py-1 wp-text">
                <span className="wp-text-small">تا </span>
                <b>{myList.End_Date}</b>
              </span>
            ) : (
              <span></span>
            )}
            {myList.Comment !== null ? (
              <span className="text-info text-danger px-2 py-1 wp-text">
                {myList.Comment}
              </span>
            ) : (
              <span></span>
            )}
          </div>
          <div className="describe wp-text">
            {/* <p className='mb-0'>نفرات ثبت نامی <span className='badge bg-primary text-white'>{myList.Count}</span></p> */}
            {/* <p className='mb-0'>حد مجاز <span className='badge bg-danger text-white'>{myList.Limited_Request}</span></p> */}
          </div>
        </div>
      </div>
    ));
    const listPlaceItems_Active = this.props.calenderPlaceJson.map((myList) => (
      <option key={myList.ID} value={myList.ID}>
        {myList.Title}
      </option>
    ));
    const listYearItems_Active = this.props.calenderYearJson.map((myList) => (
      <option key={myList.ID} value={myList.Title}>
        {myList.Title}
      </option>
    ));
    const listMonthItems_Active = this.props.calenderMonthJson.map((myList) => (
      <option key={myList.ID} value={myList.Title}>
        {myList.Title}
      </option>
    ));
    const myRequest = this.props.userRequestJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <div className="wp-text-small rounded mb-2 font-weight-bold">
          تاریخ درخواست {e.RequestTime}
        </div>
        <div className="title mb-2">
          <b>{e.Comment}</b>
        </div>
        <div className="d-inline-flex flex-row-reverse mb-2 w-100">
          {e.End_Date !== null ? (
            <span className="wp-text mr-2">
              <span className="wp-text-small">تا تاریخ </span>
              <b>{e.End_Date}</b>
            </span>
          ) : null}
          {e.Start_Date !== null ? (
            <span className="wp-text">
              <span className="wp-text-small">از تاریخ </span>
              <b>{e.Start_Date}</b>
            </span>
          ) : null}
        </div>
        <div className="d-inline-flex mb-2 w-100">
          <div className="describe ml-2">
            وضعیت تأهل: <b>{e.Married === "1" ? "مجرد" : "متأهل"}</b>
          </div>
          <div className="describe ml-2">
            تعداد اعضای خانوار: <b>{e.Count}</b>
          </div>
        </div>
        {e.describe ? (
          <div className="alert alert-warning p-2">
            <span className="wp-text-small">{e.describe}</span>
          </div>
        ) : null}
        <div className="text-left">
          <span className={e.State_CSS}>{e.State_Title}</span>
        </div>
        {e.State === "1" ? (
          <div className="text-left">
            <button
              type="button"
              onClick={() => this.handleRequest(e.ID)}
              className="btn btn-danger btn-sm rounded-pill py-0 px-1 small-font"
            >
              انصراف
            </button>
          </div>
        ) : null}
        {e.State === "2" ? (
          <>
            <div className="alert alert-danger mt-2 p-1">
              <span className="wp-text-small">
                در صورت مشخص نکردن وضعیت درخواست رزرو شما ابطال و دیگر قادر به
                ثبت نام نخواهید بود.
              </span>
            </div>
            <div className="text-left mt-2">
              <button
                type="button"
                onClick={() => this.handleReservation(e.ID)}
                className="btn btn-success btn-sm rounded-0 py-0 px-1"
              >
                تایید کردن
              </button>
              <button
                type="button"
                onClick={() => this.handleRequest(e.ID)}
                className="btn btn-danger btn-sm rounded-0 py-0 px-1"
              >
                انصراف
              </button>
            </div>
          </>
        ) : null}
        {e.Survey === true ? (
          <div className="text-left">
            <button
              type="button"
              onClick={() => this.handleSurvey(e.Survey_ID)}
              className="btn btn-warning btn-sm rounded-pill py-0 px-1 small-font"
            >
              شرکت در نظرسنجی
            </button>
          </div>
        ) : null}
      </li>
    ));
    if (this.state.isRegister === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <Slideshow></Slideshow>
            <p className="wp-header small">درخواست‌های من</p>
            <ul className="Array p-0 mb-5">
              {myRequest.length === 0 ? (
                <li className="Array-item">
                  <div className="title">
                    هنوز درخواستی توسط شما ثبت نشده است.
                  </div>
                </li>
              ) : (
                myRequest
              )}
            </ul>
            <button
              onClick={this.toggleRegister}
              className="btn btn-success wp-button-add"
            >
              <span>ثبت درخواست جدید</span>
            </button>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className="container-fluid">
            <Modal
              show={this.state.isSubmitForceRegister}
              onHide={this.toggleSubmitForceRegister}
            >
              <Modal.Header>
                <Modal.Title>مجتمع صنایع آلومینیوم جنوب</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="w-100 text-justify text">
                  <p className="mb-0">{this.state.errorMessageRegister}</p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-sm dina-btn-orange"
                  onClick={this.toggleSubmitForceRegister}
                >
                  انصراف
                </Button>
                <Button
                  className="btn btn-sm dina-btn-blue"
                  onClick={this.submitFormForce}
                >
                  ثبت
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={this.state.isSubmitForce}
              onHide={this.toggleSubmitForce}
            >
              <Modal.Header>
                <Modal.Title>مجتمع صنایع آلومینیوم جنوب</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="w-100 text-justify text">
                  <p className="mb-0">{this.state.errorMessage}</p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-sm dina-btn-orange"
                  onClick={this.toggleSubmitForce}
                >
                  انصراف
                </Button>
                <Button
                  className="btn btn-sm dina-btn-blue"
                  onClick={this.submitForm}
                >
                  ثبت
                </Button>
              </Modal.Footer>
            </Modal>
            <div className="w-100 body-padding">
              <div className="item">
                <p className="wp-header">برنامه زمانی سفر</p>
                <div className="row justify-content-center">
                  <div className="col-12 mb-2">
                    <label className="font-weight-bold">انتخاب محل اقامت</label>
                    <select
                      id="Calender_Hotel"
                      name="Calender_Hotel"
                      type="text"
                      className="form-select form-select-lg text-center wp-input-text rounded-0"
                      placeholder="محل اقامت"
                      defaultValue=""
                      onChange={this.handleYearCalender}
                    >
                      <option value="">انتخاب نمایید</option>
                      {listPlaceItems_Active}
                    </select>
                  </div>
                  <div className="col-6 mb-2">
                    <label className="font-weight-bold">سال</label>
                    <select
                      id="Calender_Year"
                      name="Calender_Year"
                      type="text"
                      className="form-select form-select-lg text-center wp-input-text rounded-0"
                      placeholder="سال"
                      defaultValue=""
                      onChange={this.handleMonthCalender}
                    >
                      {listYearItems_Active.length === 0 ? null : (
                        <option>انتخاب کنید</option>
                      )}
                      {listYearItems_Active.length === 0 ? (
                        <option value="">محل اقامت را مشخص کنید</option>
                      ) : (
                        listYearItems_Active
                      )}
                    </select>
                  </div>
                  <div className="col-6 mb-2">
                    <label className="font-weight-bold">ماه</label>
                    <select
                      id="Calender_Month"
                      name="Calender_Month"
                      type="text"
                      className="form-select form-select-lg text-center wp-input-text rounded-0"
                      placeholder="ماه"
                      defaultValue=""
                      onChange={this.handleCalenderSelect}
                    >
                      {listMonthItems_Active.length === 0 ? (
                        <option value="">سال را مشخص کنید</option>
                      ) : (
                        listMonthItems_Active
                      )}
                    </select>
                  </div>
                  <div className="col-12 mb-2">
                    <div className="w-100 d-flex flex-wrap">
                      {listItems_Active.length === 0 ? (
                        <div className="col-12 mt-2 Array-item">
                          <div className="title text-center">
                            ابتدا محل اقامت، سال و ماه را انتخاب کنید.
                          </div>
                        </div>
                      ) : (
                        listItems_Active
                      )}
                    </div>
                  </div>
                  <div className="col-12 mb-2">
                    <label className="font-weight-bold">وضعیت تأهل</label>
                    <select
                      id="Married"
                      name="Married"
                      type="text"
                      className="form-select form-select-lg text-center wp-input-text rounded-0"
                      placeholder="وضعیت تأهل"
                      defaultValue=""
                      onChange={this.handleMarried}
                    >
                      <option value="">انتخاب کنید</option>
                      <option value="1">مجرد</option>
                      <option value="2">متاهل</option>
                    </select>
                  </div>
                  <div className={this.state.marriedClass}>
                    <label className="font-weight-bold">
                      {this.state.marriedText}
                    </label>
                    <select
                      id="Count_Married"
                      name="Count_Married"
                      type="text"
                      className="form-select form-select-lg text-center wp-input-text rounded-0"
                      placeholder={this.state.marriedText}
                      defaultValue=""
                      onChange={this.handlePeopleCount}
                    >
                      <option value="0">0 نفر</option>
                      <option value="1">1 نفر</option>
                      <option value="2">2 نفر</option>
                      <option value="3">3 نفر</option>
                      <option value="4">4 نفر</option>
                    </select>
                  </div>
                  <div className={this.state.underAgeClass}>
                    <label className="font-weight-bold">
                      تعداد فرزند زیر دوسال
                    </label>
                    <select
                      id="Count_Under_Age"
                      name="Count_Under_Age"
                      type="text"
                      className="form-select form-select-lg text-center wp-input-text rounded-0"
                      placeholder="فرزندان زیر 2 سال"
                      defaultValue=""
                    >
                      <option value="0">0 نفر</option>
                      <option value="1">1 نفر</option>
                      <option value="2">2 نفر</option>
                    </select>
                  </div>
                  <div className={this.state.singleClass}>
                    <label className="font-weight-bold">
                      {this.state.marriedText}
                    </label>
                    <select
                      id="Count_Single"
                      name="Count_Single"
                      type="text"
                      className="form-select form-select-lg text-center wp-input-text rounded-0"
                      placeholder={this.state.marriedText}
                      defaultValue=""
                      onChange={this.handlePeopleCount}
                    >
                      <option value="0">0 نفر</option>
                      <option value="1">1 نفر</option>
                      <option value="2">2 نفر</option>
                    </select>
                  </div>
                  <div className="col-12 mb-2">
                    <div className="form-check text-right">
                      <input
                        className="form-check-input lawCheckbox"
                        type="checkbox"
                        value="on"
                        id="flexCheckDefault"
                      ></input>
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault"
                      >
                        <span
                          className="text-primary"
                          onClick={this.props.toggleLaw}
                        >
                          قوانین و مقررات
                        </span>{" "}
                        را مطالعه کردم و با آن موافق هستم.
                      </label>
                    </div>
                  </div>
                  <div className="col-12 text-left">
                    <button
                      onClick={this.toggleRegister}
                      className="btn btn-warning rounded-0"
                    >
                      <span>بازگشت</span>
                    </button>
                    <button
                      id="SubmitForm"
                      className="btn dina-btn-blue rounded-0"
                      onClick={this.submitPreForm}
                    >
                      <AiFillSave /> ثبت درخواست
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
  submitFormForce = () => {
    var selectCalander = false;
    var selectCalanderID = 0;
    var cusid_ele = document.getElementsByClassName("dvCalender");
    for (var i = 0; i < cusid_ele.length; ++i) {
      var item = cusid_ele[i];
      if (item.classList.contains("active") === true) {
        selectCalander = true;
        selectCalanderID = $(item).attr("data-target");
      }
    }
    if (selectCalander === true) {
      var currentMarriedValue = document.getElementById("Married").value;
      if (currentMarriedValue === null || currentMarriedValue === "") {
        const errorMessage = "وضعیت تأهل خود را مشخص نمایید.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      } else {
        var currentValue = 0;
        var CurrentValueUnderAge = 0;
        if (currentMarriedValue === "1") {
          currentValue = document.getElementById("Count_Single").value;
        } else {
          currentValue = document.getElementById("Count_Married").value;
          CurrentValueUnderAge = document.getElementById("Count_Under_Age")
            .value;
        }
        var chkLawBox = document.querySelector(".lawCheckbox:checked");
        if (chkLawBox !== null && chkLawBox.value === "on") {
          const token = localStorage.getItem("token");
          if (token !== null) {
            var formdata = new FormData();
            formdata.append("token", token);
            formdata.append("ID_Calender", selectCalanderID);
            formdata.append("Married", currentMarriedValue);
            formdata.append("UnderAge", CurrentValueUnderAge);
            formdata.append("Count", currentValue);
            var requestOptions = {
              method: "POST",
              body: formdata,
              redirect: "follow",
            };

            fetch(
              `${process.env.REACT_APP_BASE_API_URL}/api/user/add-ref-request-force`,
              requestOptions,
            )
              .then((response) => response.text())
              .then((result) => {
                if (result !== null) {
                  var myObject = JSON.parse(result);
                  if (myObject.status === 0) {
                    const errorMessage =
                      "درخواست شما با موفقیت در سامانه ثبت شد.";
                    this.props.toggleErrorMessage(errorMessage);
                    this.props.toggleError();
                    this.toggleSubmitForceRegister();
                    this.props.getUserRequest();
                    this.setState({ isRegister: true });
                  } else {
                    this.toggleSubmitForceRegister();
                    const errorMessage = myObject.message;
                    this.props.toggleErrorMessage(errorMessage);
                    this.props.toggleError();
                  }
                }
              })
              .catch((error) => console.log("error", error));
          } else {
            const errorMessage =
              "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
            this.props.toggleErrorMessage(errorMessage);
            this.props.toggleError();
          }
        } else {
          const errorMessage = "قوانین و مقررات را مطالعه و تایید نمایید.";
          this.props.toggleErrorMessage(errorMessage);
          this.props.toggleError();
        }
      }
    } else {
      const errorMessage = "برنامه زمانی مورد نظر خود را انتخاب کنید.";
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
  submitPreForm = () => {
    var selectCalander = false;
    var selectCalanderID = 0;
    var cusid_ele = document.getElementsByClassName("dvCalender");
    for (var i = 0; i < cusid_ele.length; ++i) {
      var item = cusid_ele[i];
      if (item.classList.contains("active") === true) {
        selectCalander = true;
        selectCalanderID = $(item).attr("data-target");
      }
    }
    if (selectCalander === true) {
      var currentMarriedValue = document.getElementById("Married").value;
      if (currentMarriedValue === null || currentMarriedValue === "") {
        const errorMessage = "وضعیت تأهل خود را مشخص نمایید.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      } else {
        var currentValue = 0;
        var CurrentValueUnderAge = 0;
        if (currentMarriedValue === "1") {
          currentValue = document.getElementById("Count_Single").value;
        } else {
          currentValue = document.getElementById("Count_Married").value;
          CurrentValueUnderAge = document.getElementById("Count_Under_Age")
            .value;
        }

        var chkLawBox = document.querySelector(".lawCheckbox:checked");
        if (chkLawBox !== null && chkLawBox.value === "on") {
          const token = localStorage.getItem("token");
          if (token !== null) {
            var formdata = new FormData();
            formdata.append("token", token);
            formdata.append("ID_Calender", selectCalanderID);
            formdata.append("Married", currentMarriedValue);
            formdata.append("UnderAge", CurrentValueUnderAge);
            formdata.append("Count", currentValue);
            var requestOptions = {
              method: "POST",
              body: formdata,
              redirect: "follow",
            };
            fetch(
              `${process.env.REACT_APP_BASE_API_URL}/api/user/add-ref-pre-request`,
              requestOptions,
            )
              .then((response) => response.text())
              .then((result) => {
                if (result !== null) {
                  var myObject = JSON.parse(result);
                  if (myObject.status === 0) {
                    const errorMessage = myObject.message;
                    this.setState({ errorMessage: errorMessage });
                    this.toggleSubmitForce();
                  } else {
                    const errorMessage = myObject.message;
                    this.props.toggleErrorMessage(errorMessage);
                    this.props.toggleError();
                  }
                }
              })
              .catch((error) => console.log("error", error));
          } else {
            const errorMessage =
              "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
            this.props.toggleErrorMessage(errorMessage);
            this.props.toggleError();
          }
        } else {
          const errorMessage = "قوانین و مقررات را مطالعه و تایید نمایید.";
          this.props.toggleErrorMessage(errorMessage);
          this.props.toggleError();
        }
      }
    } else {
      const errorMessage = "برنامه زمانی مورد نظر خود را انتخاب کنید.";
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
  submitForm = () => {
    var selectCalander = false;
    var selectCalanderID = 0;
    var cusid_ele = document.getElementsByClassName("dvCalender");
    for (var i = 0; i < cusid_ele.length; ++i) {
      var item = cusid_ele[i];
      if (item.classList.contains("active") === true) {
        selectCalander = true;
        selectCalanderID = $(item).attr("data-target");
      }
    }
    if (selectCalander === true) {
      var currentMarriedValue = document.getElementById("Married").value;
      if (currentMarriedValue === null || currentMarriedValue === "") {
        const errorMessage = "وضعیت تأهل خود را مشخص نمایید.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      } else {
        var currentValue = 0;
        var CurrentValueUnderAge = 0;
        if (currentMarriedValue === "1") {
          currentValue = document.getElementById("Count_Single").value;
        } else {
          currentValue = document.getElementById("Count_Married").value;
          CurrentValueUnderAge = document.getElementById("Count_Under_Age")
            .value;
        }

        var chkLawBox = document.querySelector(".lawCheckbox:checked");
        if (chkLawBox !== null && chkLawBox.value === "on") {
          const token = localStorage.getItem("token");
          if (token !== null) {
            var formdata = new FormData();
            formdata.append("token", token);
            formdata.append("ID_Calender", selectCalanderID);
            formdata.append("Married", currentMarriedValue);
            formdata.append("UnderAge", CurrentValueUnderAge);
            formdata.append("Count", currentValue);
            var requestOptions = {
              method: "POST",
              body: formdata,
              redirect: "follow",
            };

            fetch(
              `${process.env.REACT_APP_BASE_API_URL}/api/user/add-ref-request`,
              requestOptions,
            )
              .then((response) => response.text())
              .then((result) => {
                if (result !== null) {
                  var myObject = JSON.parse(result);
                  if (myObject.status === 0) {
                    const errorMessage =
                      "درخواست شما با موفقیت در سامانه ثبت شد.";
                    this.props.toggleErrorMessage(errorMessage);
                    this.props.toggleError();
                    this.props.getUserRequest();
                    this.toggleSubmitForce();
                    this.setState({ isRegister: true });
                  } else if (myObject.status === 2) {
                    this.toggleSubmitForce();
                    const errorMessage = myObject.message;
                    this.setState({ errorMessageRegister: errorMessage });
                    this.toggleSubmitForceRegister();
                  } else {
                    const errorMessage = myObject.message;
                    this.props.toggleErrorMessage(errorMessage);
                    this.props.toggleError();
                  }
                }
              })
              .catch((error) => console.log("error", error));
          } else {
            const errorMessage =
              "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
            this.props.toggleErrorMessage(errorMessage);
            this.props.toggleError();
          }
        } else {
          const errorMessage = "قوانین و مقررات را مطالعه و تایید نمایید.";
          this.props.toggleErrorMessage(errorMessage);
          this.props.toggleError();
        }
      }
    } else {
      const errorMessage = "برنامه زمانی مورد نظر خود را انتخاب کنید.";
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
  handleMarried = (e) => {
    if (e.target.value === "2") {
      this.setState({ marriedText: "تعداد فرزندان تحت تکفل" });
      this.setState({ marriedClass: "col-12 mb-2" });
      this.setState({ singleClass: "col-12 mb-2 hide" });
    } else if (e.target.value === "1") {
      this.setState({ marriedText: "پدر و مادر تحت تکفل" });
      this.setState({ marriedClass: "col-12 mb-2 hide" });
      this.setState({ singleClass: "col-12 mb-2" });
    } else {
      this.setState({ marriedText: "" });
      this.setState({ marriedClass: "col-12 mb-2 hide" });
      this.setState({ singleClass: "col-12 mb-2 hide" });
    }
  };
  handlePeopleCount = (e) => {
    var handleMarried = e.target.name;
    if (handleMarried === "Count_Married") {
      const currentValue = e.target.value;
      if (currentValue > 0) {
        this.setState({ underAgeClass: "col-12 mb-2" });
      } else {
        this.setState({ underAgeClass: "col-12 mb-2 hide" });
      }
    } else {
      this.setState({ underAgeClass: "col-12 mb-2 hide" });
    }
  };
  selectCalender = (id, e) => {
    if (id !== null && id !== this.state.calenderSelectID) {
      console.log("here");
      this.setState({ calenderSelectID: id });
      var cusid_ele = document.getElementsByClassName("dvCalender");
      for (var i = 0; i < cusid_ele.length; ++i) {
        var item = cusid_ele[i];
        var getValue = $(item).attr("data-target");
        if (getValue.includes(id)) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      }
    }
  };
  handleYearCalender = () => {
    const Hotel = document.getElementById("Calender_Hotel");
    if (Hotel !== null && Hotel.value !== "") {
      this.props.clearCalender();
      this.props.getCalenderYear(Hotel);
    }
  };
  handleMonthCalender = () => {
    const Hotel = document.getElementById("Calender_Hotel");
    const Year = document.getElementById("Calender_Year");
    if (Year !== null && Year.value !== "") {
      this.props.clearCalender();
      this.props.getCalenderMonth(Hotel, Year);
    }
  };
  handleCalenderSelect = () => {
    const Hotel = document.getElementById("Calender_Hotel");
    const Year = document.getElementById("Calender_Year");
    const Month = document.getElementById("Calender_Month");
    if (Month !== null && Month.value !== "") {
      this.props.getCalender(Hotel, Year, Month);
    }
  };
  handleRequest = (e) => {
    this.props.declineRequest(e);
  };
  handleSurvey = (e) => {
    this.props.participateSurvey(e);
  };
  handleReservation = (e) => {
    this.props.acceptReservation(e);
  };
}
export default Refahi;
